export const PAGE_NAMES = {
	DELIVERY: "delivery",
	paymentMethod: "paymentMethod",
	terms: "terms",
	about: "about",
};
